<template>
    <div class="handlers" :class="handlerClass">
        <a v-if="telephone" :href="telephoneHref"><span class="fas fa-phone"></span> {{ telephone }}</a>
        <span class="trigger"  @click.prevent="expand">
            <span class="openLabel" v-show="!expanded">OPEN MENU</span>
            <span class="closeLabel" v-show="expanded">CLOSE MENU</span>
            <span class="fas fa-bars"></span>
        </span>
    </div>
</template>
<script>
    export default {
        props: {
            telephone: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                expanded: false
            };
        },
        computed: {
            telephoneHref() {
                return 'tel:' + this.telephone.replace(/\s/g,'');
            },
            handlerClass() {
                return {
                    'with-telephone': this.telephone
                }
            }
        },
        mounted() {
            EventHandler.listen('navigation-hidden', () => { this.expanded = false });
        },
        methods: {
            expand() {
                this.expanded = !this.expanded;
                EventHandler.fire('expand-navigation');
            }
        }
    };
</script>